import axios from 'axios';
import errorMessage from './errorMessage';
import { updateUserBalance } from 'Store/actions/authActions';
import ProjectConfig from 'ProjectConfig';
import EnvironmentManager from 'Utils/environmentManager';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

const CMS_BILYON_CARD_ERROR = EnvironmentManager.getMessageText({ key: 'bilyoncard-manager4011' }) || 'Bilyonkart\'ını etkinleştirmek için Bize Yazın bölümünden ya da 0850 272 0 272 numaralı müşteri hizmetlerimizden destek alabilirsin..';

export const loadBilyoncard = formData => dispatch => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(
        `${API_GATEWAY}/bilyoncard-manager/bilyoncard/load`,
        {
          ...formData,
          channel: 'WEB'
        }
      );

      dispatch(updateUserBalance());
      resolve(res);
    } catch (e) {
      if (e?.response?.data?.code === 4011) {
        return reject(CMS_BILYON_CARD_ERROR);
      }
      reject(e.response && e.response.data && e.response.data.message || errorMessage);
    }
  });
};
